import { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import LoanExpectedRightPanel from './LoanExpectedRightPanel'
import Modal from '../../../common/ModalPopup';
import InsuranceEditForm from './InsuranceEditForm';
import AddonForm from './AddonForm'
import QuotesDetail from './QuotesDetail'
import InsuranceService from 'services/InsuranceService';
import { callServiceToCreateLead, getAddonList, getAddonListID, isShowDynamicField } from '../create/FunctionList'
import { useSelector, useDispatch } from 'react-redux';
import FullPageLoader from '@src/common/FullPageLoader';
import { downloadLoanQuotationPdf, fetchLeadData, updateLeadDetailsInStore, fetchQuoteDetails, getLeadEmailTemplates, setQuotationAddonsData } from "@src/store/slices/insurance";
import ShareQuotesDetail from './ShareQuotesDetail';
import ShareQuotesDetailID from './ShareQuotesDetailID';
import {STATUS_SUB_STATUS, ROLE_FEATURES, APP_TYPE_STANDALONE, APP_TYPE_WITH_UCF, API_TYPES, INS_TYPE_CTPL, ALLOW_LEAD_SOURCE,MARKETING_LEAD_SOURCE,DSA_LEAD_SOURCE, INSTALLMENT, APP_TYPE_RENEWAL, ENCRYPTED_FIELDS, APP_TYPE_AGENCY, WITH_RULE_ENGINE,APP_AGENCY,EFFECTIVITY_EXPIRY_INTERVAL,COUNTRY_CODE,VEHICLE_TYPE_MOTORCYCLE,VEHICLE_TYPE_MOTORCYCLE_COMMERCIAL, STATUS_SUCCESS, LEAD_TYPE_CRM} from '@src/config/constant';
import { toast } from 'react-toastify';
import * as HELPER from "@src/config/helper";
import { getMMVList } from '@src/store/slices/common';
import AgencyService from '@src/services/AgencyService';
import QuotesDetailID from './QuotesDetailID';
import { callServiceToUpdateLead } from '../detail/FunctionList';
import { useLanguage } from '@src/context/LanguageContext';

import moment from 'moment';
import { LEAD_DETAIL_AMOUNT_FIELDS, POLICY_HOLDER, SELECTED_TENURE_YEAR, VEHICLE_USAGE_ID } from '@src/config/id/constant';
  
const LoanExpected = () => {
    const queryParams = useParams();
    const [displayBlock, setDisplayBlock]: any = useState("SUMMARY");
    const [showApproveBtn, setShowApproveBtn] = useState<boolean>(false);
    const [addons, setAddons]: any = useState(false);
    const [addonList, setAddonList] = useState<any>([]);
    const [formData, setFormData] = useState([]);
    const [leadDetails, setLeadDetails] = useState({});
    const [loanQuote, setLoanQuote] = useState<any>(null);
    const allState = useSelector((state: any) => state);
    const [loading, setLoading] = useState<boolean>(false)
    const [value, setValue] = useState(1)
    const [showShareLoanQuote, setShowShareLoanQuote] = useState<boolean>(false)
    const dispatch: any = useDispatch();
    const [addonCount, setAddonCount] = useState(0);
    const [insuranceType, setInsuranceType] = useState<any>('');
    const [financeType, setFinanceType] = useState<any>('');
    const [vehicleType, setVehicleType] = useState<any>('');
    const [vehicleusage, setVehicleUsage] = useState<any>('');
    const [totalAddonPremiumAmt, setTotalAddonPremiumAmt] = useState<string>("");
    const {translations} = useLanguage();

    const insuranceState = (allState.insurance && allState.insurance.leadDetail) ? allState.insurance.leadDetail : null;
    const insuranceQuotesState = (insuranceState) ? insuranceState.quotes : null;
    const vehicleTypeList = allState?.common?.common?.vehicle_type || [];
    const insuranceStateStore = useSelector((state: any) => state.insurance);
    const [premiumAmountState, setPremiumAmountState] = useState<{ [key: number]: any }>({});
    const [isAddonEdit, setIsAddonEdit] = useState(false);
    // ---- ID multi-year calculator state ----
    const [tenure, setTenure] = useState<number>(0); // 0 => use the saved lead tenure
    const [yearTypes, setYearTypes] = useState<number[]>([]); // insurance_type_id per policy year
    const [yearAddonSelections, setYearAddonSelections] = useState<Record<number, number[]>>({}); // selected addon ids per policy year
    const [addonModalYear, setAddonModalYear] = useState<number>(1);
    const [needsRecalc, setNeedsRecalc] = useState<boolean>(false);
    
    
    
    /* ---------------- ID multi-year helpers ---------------- */
    const getSavedTenure = () => Number(insuranceState?.tenure) || insuranceState?.lead_tenure_data?.length || 1;
    const effectiveTenure = tenure || getSavedTenure();

    const getSavedYearTypes = (): number[] => {
        const rows = [...(insuranceState?.lead_tenure_data || [])]
            .sort((a: any, b: any) => +a.tenure - +b.tenure)
            .map((row: any) => +row.insurance_type_id)
            .filter(Boolean);
        return rows.length ? rows : [+insuranceState?.insurance_type_id || 1];
    };

    // shrink / extend the per-year insurance types; new years inherit the last year's type (keeps "no Comprehensive after TLO")
    const resizeYearTypes = (types: number[], years: number) => {
        const out = types.slice(0, years);
        while (out.length < years) out.push(out[out.length - 1] || 1);
        return out;
    };

    const uniqueIds = (list: any[]) => Array.from(new Set((list || []).map((a: any) => +a.id).filter((id: number) => !isNaN(id))));

    const buildInitialYearSelections = (years: number) => {
        const allRows: any[] = insuranceState?.addon_detail_all || insuranceState?.addon_detail || [];
        const hasTenureInfo = allRows.some((a: any) => a?.tenure);
        const year1 = uniqueIds(allRows.filter((a: any) => !a?.tenure || +a.tenure === 1));
        const savedYears = getSavedTenure();
        const selections: Record<number, number[]> = { 1: year1 };
        for (let year = 2; year <= years; year++) {
            selections[year] = (hasTenureInfo && year <= savedYears)
                ? uniqueIds(allRows.filter((a: any) => +a.tenure === year)).filter((id: number) => year1.includes(id))
                : [...year1]; // year not saved yet => carry Year 1 forward
        }
        return selections;
    };

    const resizeYearSelections = (selections: Record<number, number[]>, years: number) => {
        const year1 = selections?.[1] || [];
        const out: Record<number, number[]> = { 1: [...year1] };
        for (let year = 2; year <= years; year++) {
            out[year] = selections?.[year] ? selections[year].filter((id: number) => year1.includes(id)) : [...year1];
        }
        return out;
    };

    const initYearState = () => {
        const years = getSavedTenure();
        setTenure(years);
        setYearTypes(resizeYearTypes(getSavedYearTypes(), years));
        setYearAddonSelections(buildInitialYearSelections(years));
        setNeedsRecalc(false);
    };

    const getMultiYearPayload = () => {
        const types = yearTypes.length ? yearTypes : getSavedYearTypes();
        return resizeYearTypes(types, effectiveTenure).map((type: number) => ({ insurance_type: type }));
    };

    // attach `tenures` (policy years the addon applies to) to every Year 1 addon
    const withAddonTenures = (list: any[]) => {
        if (!Array.isArray(list)) return list;
        if (effectiveTenure <= 1) return list.map(({ tenures, ...rest }: any) => rest);
        return list.map((addon: any) => {
            const years = [];
            for (let year = 1; year <= effectiveTenure; year++) {
                if (year === 1 || (yearAddonSelections?.[year] || []).includes(+addon.id)) years.push(year);
            }
            return { ...addon, tenures: years };
        });
    };

    const onTenureChange = (years: number) => {
        if (!years || years === effectiveTenure) return;
        setTenure(years);
        setYearTypes(resizeYearTypes(yearTypes.length ? yearTypes : getSavedYearTypes(), years));
        setYearAddonSelections(resizeYearSelections(Object.keys(yearAddonSelections).length ? yearAddonSelections : buildInitialYearSelections(years), years));
        setNeedsRecalc(true);
    };

    useEffect(() => {
        fetchQuotesData()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])
    
    useEffect(() => {
        const fetchData = async () => {
            try {
                let matchingAddons = [];
                if(loanQuote && loanQuote?.addon_list){
                    matchingAddons = loanQuote?.addon_list
                    dispatch(setQuotationAddonsData(matchingAddons));
                }                
            } catch (error) {
                console.error("Error fetching addon data:", error);
            }
            
        };
    
        fetchData();
    }, [dispatch, insuranceType, insuranceState,loanQuote]);
    

    useEffect(() => {

        if (!insuranceType && insuranceState && insuranceState.insurance_type_id) {
            setInsuranceType(insuranceState.insurance_type_id);
        }
        if (!financeType && insuranceState && insuranceState.is_under_financing) {
            setFinanceType(+insuranceState.is_under_financing);
        }
        if (!vehicleusage && insuranceState && insuranceState.vehicle_id) {
            setVehicleUsage(+insuranceState.vehicle_id);
        }
        if (!vehicleType && insuranceState && insuranceState.vehicle_type_id) {
            setVehicleType(+insuranceState.vehicle_type_id);
        }

        // eslint-disable-next-line  
    }, [allState.insurance, allState.insurance.leadDetail]);

    const fetchQuotesData = async () => {
        setLoading(true)
        try {
            const [leadResult, quoteResult]: any = await Promise.all([
                fetchLeadData({ lead_id: queryParams.id, apiType: API_TYPES['customerData'] }),
                fetchQuoteDetails({ lead_id: queryParams.id })
            ])

            if (
                (leadResult && leadResult?.status === STATUS_SUCCESS) ||
                (quoteResult && quoteResult?.status === STATUS_SUCCESS)
            ) {
                const leadDetails = allState?.insurance?.leadDetail || {}
                const leadData = leadResult?.status === STATUS_SUCCESS ? (leadResult?.data || {}) : {}
                const quoteData = quoteResult?.status === STATUS_SUCCESS ? (quoteResult?.data || {}) : {}
                let selectedAddons = quoteData?.addon_detail || leadData?.addon_detail;

                if (COUNTRY_CODE === 'id' && selectedAddons) {
                    const allTenureAddons = [...selectedAddons] // every policy year, used by the year-wise calculator
                    selectedAddons = selectedAddons?.filter((item: any) => +item.tenure === SELECTED_TENURE_YEAR)
                    if (quoteData?.addon_detail) {
                        quoteData.addon_detail = selectedAddons;
                        quoteData.addon_detail_all = allTenureAddons;
                    } else {
                        leadData.addon_detail = selectedAddons;
                        leadData.addon_detail_all = allTenureAddons;
                    }
                }

                dispatch(updateLeadDetailsInStore({
                    ...leadDetails,
                    ...leadData,
                    ...quoteData,
                    quotes: {
                        ...leadDetails.quotes,
                        ...leadData?.quotes,
                        ...quoteData?.quotes
                    }
                }))
            }
        } finally {
            setLoading(false)
        }
    }

    const toggleswitch = (type: any) => {
        setLoading(true)
        if (type === 'EDITVIEW') {
            if (COUNTRY_CODE !== 'id') {
                let params = {
                    rule_engine: insuranceState.rule_engine_id,
                    vehicle_usage: insuranceState.vehicle_id,
                    apptype: insuranceState.application_type_id,
                    vehicle_type: insuranceState.vehicle_type_id
                }
                dispatch(getMMVList(params))
                .then((res: any) => setLoading(false))
                .catch((err: any) => setLoading(false))
                if(insuranceState?.application_type_id === APP_AGENCY){

                    InsuranceService.getPartnerList({...params, agency_id: insuranceState?.agency_id, insurance_type: insuranceState?.insurance_type_id, total_fmv: insuranceState?.total_fmv, make_year: insuranceState?.make_year,tenure:insuranceState?.tenure, engine_capacity: insuranceState?.engine_capacity || undefined}).then(res=>{
                        if(res?.data?.data?.[0]?.id !== insuranceState?.partner_id){
                           // dispatch(updateLeadDetailsInStore({ ...insuranceState, partner_id: res?.data?.data?.[0]?.id, partner_slug: res?.data?.data?.[0]?.slug }))
                            dispatch(updateLeadDetailsInStore({ ...insuranceState, partner_id: insuranceStateStore.leadDetail.partner_id, partner_slug: insuranceStateStore.leadDetail.partner_slug }))
    
                        }
                    })
                }    
            }  
        }

        setLoading(false)

        setAddonCount(insuranceState?.addon_detail?.length);
        setDisplayBlock(type)
        setVehicleType(insuranceState?.vehicle_type_id)
        setAddonList([])
        setPremiumAmountState({})
        setIsAddonEdit(false)
        if (COUNTRY_CODE === 'id') initYearState()
    }

    const showHideAddons = (action: any, params?: any, year?: number) => {
        if (action) setAddonModalYear(year && year <= effectiveTenure ? year : 1)

        if(params && COUNTRY_CODE === 'id'){
            for(let key in params){
                params[key] = HELPER.removeCurrencyFormattingId(params[key]);
            }
        }
        
        setAddons(action)
        document.body.classList.remove("overflow-hidden");

        if (action) {
            if (COUNTRY_CODE === 'id') {
                fetchAddonsID(params)
            } else {
                fetchAddons();
            }
        }
    }

    const showModalFinancerEmail = () => {
        setShowShareLoanQuote(!showShareLoanQuote)
    }

    const fetchAddons = async (insuranceid=null) => { 
        setLoading(true) 
        let params = { 
            rule_engine:insuranceState?.rule_engine_id, 
            vehicle_type:(vehicleType)?vehicleType:insuranceState?.vehicle_type_id, 
            apptype:insuranceState?.application_type_id, 
            insurance_type:(insuranceid)?insuranceid:insuranceType,
            make_year:insuranceState?.make_year,
            source: (insuranceState?.application_type_id === APP_TYPE_AGENCY) ? "agency_app" : undefined,
            lead_type: +insuranceState?.lead_type
        }
        let result = await InsuranceService.getAddonList(params)
        setLoading(false)
        if (result?.data?.data) {
            for (let data of result.data.data) {
                if (data.id === 3) {
                    data.extra_seat_capacity = '';
                }
                let addonField = getAddonList([], addonList);
                let addonData = (addonField && addonField.length > 0) ? addonField : insuranceState?.addon_detail;
                
                if (+insuranceType === +insuranceState?.insurance_type_id && +vehicleusage === +insuranceState?.vehicle_id && +vehicleType === +insuranceState?.vehicle_type_id) {

                    let addonIds = addonData.filter((item: any) => item.id === data.id);
                    if (addonIds.length > 0) {
                        data.coverage_amt = addonIds[0].coverage_amount;
                        data.premium_amount = addonIds[0].premium_amount;
                        data.is_selected = true;
                        if (addonIds[0].id === 3) {
                            data.seat_capacity = addonIds[0].seat_capacity;
                            data.extra_seat_value = addonIds[0].extra_seat_capacity;
                        }
                    } else {
                        data.is_selected = false;
                    }
                }
                if (data.id === 6) {
                    if (+insuranceType === 1 && +financeType === 1) {
                        data.is_required = true;
                        data.is_selected = true;
                    }
                }

            }
            let resultcount = result?.data?.data?.filter((item: any) => item.is_selected === true);
            setAddonList([...result.data.data]);
            setAddonCount(resultcount.length)
        }
    }

    const fetchAddonsID = async (reqparams?: any,internalCall:boolean=false) => {
        setLoading(true)
 
        
        let params = {
            // insurance_type: insuranceType,
            vehicle_type: insuranceState?.vehicle_type_id,
            plate_area_type: +insuranceState?.plate_number_region,
            plate_area:    insuranceState?.plate_area,
            insurer_id: insuranceState?.insurer_id,
            make_year: insuranceState?.make_year,
            total_fmv: reqparams?.total_fmv || insuranceState?.total_fmv,
            multi_year: getMultiYearPayload(),
            tenure: effectiveTenure,
            vehicle_condition: insuranceState?.vehicle_condition_id,
            vehicle_usage : insuranceState?.usage_type,
            rule_engine:insuranceState?.rule_engine_id,
            lead_id:+insuranceState?.lead_id
        }
        

        // if(internalCall) params.insurance_type = insuranceState.insurance_type_id; 
        let result = await InsuranceService.getAddonListID(params)
        setLoading(false)

        if (result?.status === STATUS_SUCCESS && result?.data?.data) {
            let data = result?.data?.data
            data = { basic: data?.basic, special: data?.special }

            let updatedAddons: any = {}
            let addonDetailInState: any = getAddonListID(addonList?.basic?.concat(addonList?.special))

            addonDetailInState = addonDetailInState?.length ? addonDetailInState : insuranceState?.addon_detail

            let count: any = 0

            for (let key in data) {
                let type = key
                let addons: any = []
                for (let child of data[key]) {
                    let addonInState = addonDetailInState?.find((e: any) => e.id === child.id)
                    count += (addonInState ? 1 : 0)

                    let addonObj = {
                        ...child,
                        is_selected: addonInState ? true : false,
                        category: type,
                    }

                    if (!child?.coverage_list?.length && type !== 'special') {
                        // addonObj['premium_amount'] = (insuranceState['rule_engine_id'] !== WITH_RULE_ENGINE) ? addonInState?.coverage_amount:Math.round(addonObj['rate'] * +params.total_fmv/100)
                    } else {
                        addonObj['coverage_amt'] = addonInState?.coverage_amount ? addonInState?.coverage_amount : (addonObj?.['default_sum_insured'] || null)
                    }

                    if (child?.seat_capacity_list?.length) {
                        addonObj['seat_capacity'] = addonInState?.seat_capacity || (child?.default_passenger || null)
                    }

                    addons.push(addonObj)
                }
                updatedAddons[key] = addons
            }
            if(internalCall) return updatedAddons
            setAddonList(updatedAddons)
            setAddonCount(count)
        }
    }

    const isValidAllField = (sectionItem: any) => {
        // when sectionItem.blocks is undefined handle that case,
        if (!sectionItem || !sectionItem.blocks) {
            return false;
        }

        let flag = true
        let blockList = sectionItem['blocks'] as []
        // eslint-disable-next-line  
        blockList?.map((blockItem: any) => {
            // eslint-disable-next-line  
            blockItem.fields.map((fieldItem: any) => {
                let isValue = false;
                if (['make', 'model', 'version'].includes(fieldItem.name)) {
                    isValue = (fieldItem?.value || fieldItem?.value === 0) ? true : false;
                } else {
                    isValue = fieldItem?.value ? true : false
                }


                if (['financier'].includes(fieldItem.name)) {
                    isValue = fieldItem?.value === "" ? false : true
                }
                 if (fieldItem.name === 'expiry_date' || fieldItem.name === 'effectivity_date') {
                    let expiryDate = blockItem.fields.find((f: any) => f.name === 'expiry_date')?.value;
                    let effectivityDate = blockItem.fields.find((f: any) => f.name === 'effectivity_date')?.value;
    
                    if (!expiryDate || !effectivityDate) {
                        let missingField = !expiryDate ? 'expiry_date' : 'effectivity_date';
                        let msg = missingField.replaceAll('_', " ");
                        fieldItem['error_message'] = `Insurance policy ${msg} is required`;
                        setValue(value + 1)
                        flag = false;
                    } else {
                        let checkIfExpiryValid = moment(expiryDate).isBefore(effectivityDate);

                        if (checkIfExpiryValid) {
                            if (fieldItem.name === 'expiry_date') {
                                fieldItem['error_message'] = `The Expiry date cannot be earlier than the Effectivity date.`;
                                flag = false;
                                setValue(value + 1)
                            }
                        } else {
                            let checkIfEffDateValid = moment(expiryDate).startOf('day').diff(moment(effectivityDate).startOf('day'), 'days') < 60;
                    
                            if (checkIfEffDateValid && fieldItem.name === 'expiry_date') {
                                fieldItem['error_message'] = `Interval between Expiry date and Effectivity date should be of ${EFFECTIVITY_EXPIRY_INTERVAL} days`;
                                setValue(value + 1)
                                flag = false;
                            }
                        }
                    }
                }
                if (fieldItem.type === 'select_addon') {
                    //
                } else if (isShowDynamicField(fieldItem, blockList, { apptype: insuranceState?.application_type_id }) && fieldItem.is_required && (!isValue)) {

                    if (fieldItem?.name === "financier_name") {

                        let filterItemParent = blockItem?.fields?.filter((item: any) => item.name === "financier")?.[0]
                        if (filterItemParent?.value === 0 || filterItemParent?.value?.value === 0) {
                            fieldItem['error_message'] = fieldItem.error_msg
                            flag = false
                            setValue(value + 1)
                        }
                    } else {


                        fieldItem['error_message'] = fieldItem.error_msg
                        flag = false
                        setValue(value + 1)
                    }
                }

            })
        })

        return flag
    }

    const setAddon = (popupAddons: any) => {
        let addonField = getAddonList([], popupAddons);
        setAddonList([...popupAddons]);

        setAddonCount(addonField?.length);
    }

    const setAddonID = (popupAddons: any, selections?: Record<number, number[]>) => {
        let addonField: any = getAddonListID(popupAddons?.basic?.concat(popupAddons?.special));
        let addons: any = { basic: [], special: [] }

        for (let addon of addonField) {
            let type = addon?.['category']
            addons[type] = [...addons[type], addon]
        }

        // Year 1 is always the modal's checked list; later years can only keep Year 1 addons
        const year1 = uniqueIds(addonField);
        const updatedSelections: Record<number, number[]> = { 1: year1 };
        for (let year = 2; year <= effectiveTenure; year++) {
            const source = selections?.[year] ?? yearAddonSelections?.[year] ?? year1;
            updatedSelections[year] = source.filter((id: number) => year1.includes(+id));
        }
        if (JSON.stringify(updatedSelections) !== JSON.stringify(yearAddonSelections)) setNeedsRecalc(true);
        setYearAddonSelections(updatedSelections);

        setAddonList(addons)
        setAddonCount(addonField?.length);
    }

    const calculateInsurance = async (formData: any, reqparams: any = {}) => {
        if (isValidAllField(formData[0])) {
            setLoading(true)
            let response = callServiceToCreateLead(formData, { type: 'edit' });
            let addonField = getAddonList([], addonList);

            let params: any = {
                partner_id: insuranceStateStore.leadDetail.partner_id,
                partner_slug: insuranceStateStore.leadDetail.partner_slug,
                lead_type: insuranceState?.lead_type,
                role_id: insuranceState?.role_id,
                rule_engine: insuranceState?.rule_engine_id,
                apptype: insuranceState?.application_type_id,
                vehicle_usage: response.vehicle_usage,
                insurance_type: response.insurance_type,
                total_fmv: response.total_fmv,
                lead_id: +insuranceState?.lead_id,
                vehicle_type: vehicleType ? vehicleType : insuranceState?.vehicle_type,
                version_id: insuranceState?.version,
                mfg_year: response.make_year || insuranceState?.mfg_year,
                engine_capacity: response?.engine_capacity || insuranceState?.engine_capacity || undefined,
            } 

            //CHECK IF PATNER NOT FOUND THEN FETCH PARTNER
            if(insuranceState.application_type_id === APP_TYPE_AGENCY) {
                let latestPartnerCheck = await InsuranceService.getPartnerList({
                    rule_engine: insuranceState.rule_engine_id, 
                    vehicle_usage : response.vehicle_usage,
                    apptype: insuranceState.application_type_id,
                    vehicle_type: response.vehicle_type, 
                    agency_id: insuranceState?.agency_id, 
                    insurance_type: insuranceState?.insurance_type_id, 
                    total_fmv: insuranceState?.total_fmv, 
                    make_year: insuranceState?.make_year,
                    engine_capacity: response?.engine_capacity || insuranceState?.engine_capacity || undefined,
                    tenure:insuranceState?.tenure})
                 
                    //UPDATE NEW PARTNER // condition commment becuase quote detatisl base issue rate not show update
                if(latestPartnerCheck?.data?.data?.[0]?.id !== insuranceState?.partner_id){
                   // params['partner_id']    = latestPartnerCheck?.data?.data?.[0]?.id;
                  //  params['partner_slug']  = latestPartnerCheck?.data?.data?.[0]?.slug;
                    
                  //  dispatch(updateLeadDetailsInStore({ ...insuranceState, partner_id: insuranceStateStore?.leadDetail?.partner_id, partner_slug: insuranceStateStore?.leadDetail?.partner_slug }))
                }
            }

            if (response && response?.tenure) {
                params["tenure"] = response?.tenure;
            }

            if (insuranceState && insuranceState?.referrer_mark_up) {
                params["referrer_mark_up"] = insuranceState?.referrer_mark_up;
            }
           
            if (reqparams && (reqparams["net_premium"] || reqparams["net_premium"] === 0)) { //SEND NET PREMIUM ONLY IF SELECTED
                params["net_premium"] = reqparams["net_premium"]
            }
            if (reqparams && (reqparams["referrer_mark_up"] || reqparams["referrer_mark_up"] === 0)) { //SEND REFERRER MARK UP ONLY IF SELECTED
                params["referrer_mark_up"] = reqparams["referrer_mark_up"]
            }
            if (addonField.length > 0) {
                params["addon_detail"] = addonField;
            } else {
                params["addon_detail"] = insuranceState?.addon_detail
            }

            if (reqparams.add_on_rate) {
                params['add_on_rate'] = reqparams.add_on_rate
                if (params?.['rule_engine'] === WITH_RULE_ENGINE) {
                    delete params.net_premium
                }
            }

            //for handling discount
            if([APP_TYPE_STANDALONE, APP_TYPE_RENEWAL,APP_TYPE_AGENCY].includes(insuranceState?.application_type_id)) {
                params.last_premium = loanQuote?.gross_premium || insuranceState?.gross_premium
                params.discount = (reqparams.discount || reqparams.discount === 0) ? reqparams.discount : ((loanQuote?.discount || loanQuote?.discount === 0) ? loanQuote.discount : insuranceState?.discount)
            }

            //handle proposed fmv
            if (insuranceState.application_type_id === APP_TYPE_WITH_UCF) {
                params.proposed_fmv = response.proposed_fmv || 0
            }
            if (insuranceState.application_type_id === APP_AGENCY) {
                params["agency_id"] = insuranceState?.agency_id
            }

            let result = await InsuranceService.getAddonDetails(params);
            setLoading(false)
            if (result?.data?.status === STATUS_SUCCESS) {
                let updatedData = { ...result.data.data }
                setLeadDetails(response);
                setFormData(formData);
                setLoanQuote({ ...updatedData })
                setDisplayBlock("SUMMARY");
                setShowApproveBtn(true);
            } else {
                toast.error(result?.data?.message);
            }


        }
    }

    // getAddonDetailsID params - shared by Calculate and the live commercial-terms preview while typing
    const buildInsuranceIDParams = (data: any, extraParams: any = {}): any => {
        let error = false
        let msg = ``
        let dynamicKeys = ['car_fmv', 'acc_price', 'total_fmv', 'customer_discount', 'customer_discount_per']


        if(COUNTRY_CODE === 'id'){
            for(let row of data) {
                if(LEAD_DETAIL_AMOUNT_FIELDS?.includes(row.key)) {
                  row.value = HELPER.removeCurrencyFormattingId(row.value);
                }
            }
        }

        const insuranceExists = data.find((item:any) => item.key === "insurance_exists")?.value?.value;
        const expire_date = data.find((item:any) => item.key === "insurance_expire_date")?.value;        

        if (insuranceExists === 1 && !expire_date) {
            error = true
            msg = `Please fill all mandatory fields`
        }

        let params: any = {}
        for (let key of dynamicKeys) {
            params[key] = +data?.find((e: any) => e.key === key)?.value
            
            if ( !['acc_price','customer_discount','customer_discount_per'].includes(key) && !params[key]) { 
                error = true
                msg = `Please fill all mandatory fields`
                break
            }
        }

        if (error) return { error: msg }
        params = {
            ...params,
            sort_by: 'RC',
            vehicle_condition: insuranceState?.vehicle_condition_id,
            insurer_id: insuranceState?.insurer_id,
            insurance_type: insuranceState?.insurance_type_id,
            vehicle_type: insuranceState?.vehicle_type,
            // same plate area type as the lead (lvd.plate_area_type) - the approve/save call sends this too; it drives the basic premium rate
            plate_area_type: +insuranceState?.plate_number_region || 1,
            make: insuranceState?.make,
            make_year: insuranceState?.make_year,
            vehicle_usage: VEHICLE_USAGE_ID[insuranceState?.vehicle_usage],
            rule_engine: insuranceState.rule_engine_id,
            insurance_starting_date:  moment(insuranceState?.insurance_starting_date || insuranceState?.insurance_start_date).format('YYYY-MM-DD')
          //  addon_detail: getAddonListID(addonList?.basic?.concat(addonList?.special)) || insuranceState?.addon_detail,
        }
        

        let addonListData = getAddonListID(addonList?.basic?.concat(addonList?.special));

        params["addon_detail"] =
        addonCount !== 0
            ? addonListData.length > 0
            ? addonListData
            : insuranceState?.addon_detail
            : [];
        if (Array.isArray(params?.addon_detail)) { 
            params.addon_detail = params.addon_detail.map((item: any) => ({ ...item, premium_amount:typeof item.premium_amount === "string" ? Number(item.premium_amount) : item.premium_amount,}));
        }
        params.addon_detail = withAddonTenures(params.addon_detail);
        delete params.insurance_type;  
        params.tenure = effectiveTenure;
        params.multi_year = getMultiYearPayload();
        params.lead_type = insuranceState?.lead_type;
        params.policy_holder = insuranceState?.policy_holder;
        if (+insuranceState?.lead_type === LEAD_TYPE_CRM) {
            const fieldValue = (key: string) => data?.find((e: any) => e.key === key)?.value;
            const agentCommissionPer = Number(fieldValue('agent_commision') ?? insuranceState?.agent_commision) || 0;
            const agentPointPer = Number(fieldValue('point_commision') ?? insuranceState?.point_commision) || 0;
            if (agentCommissionPer) params.agent_commision = agentCommissionPer;
            if (agentPointPer) params.request_agent_point = agentPointPer;
        }
        // lets the pricing use this lead's saved (possibly customised) depreciation rates, same as the save path
        if (insuranceState?.lead_id) params.lead_id = +insuranceState.lead_id;

        // whole-policy customer cashback: only the field the user actually edited is sent
        const cashbackParams = extraParams?.cashback || {};
        params = { ...params, ...cashbackParams };
        return { params, cashbackParams };
    }

    // live preview (no view switch / toasts): returns the first quotation for the current inputs, or null
    const previewInsuranceID = async (data: any, extraParams: any = {}) => {
        const built = buildInsuranceIDParams(data.map((row: any) => ({ ...row })), extraParams);
        if (built.error) return null;
        try {
            const result = await InsuranceService.getAddonDetailsID(built.params);
            return result?.status === STATUS_SUCCESS ? (result?.data?.data?.quotation?.[0] || null) : null;
        } catch (e) {
            return null;
        }
    }

    const calculateInsuranceID = async (data: any, extraParams: any = {}) => {
        setLoading(true)
        const built = buildInsuranceIDParams(data, extraParams);
        if (built.error) {
            setLoading(false)
            return toast.error(built.error)
        }
        const { params, cashbackParams } = built;
        let result = await InsuranceService.getAddonDetailsID(params);
        setLoading(false)

        if (result?.status === STATUS_SUCCESS && result?.data?.data && !result?.data?.data?.quotation?.length) {
            return toast.error(translations.Insurance?.['No quotation available for the selected configuration'] || 'No quotation available for the selected configuration');
        }

        if (result?.status === STATUS_SUCCESS && result?.data?.data) {
            let { quotation } = result?.data?.data
            let updatedData = data?.map((e: any) => {
                return { [e.key]: e.value }
            })?.reduce((acc: any, item: any) => {
                return { ...acc, ...item };
            }, {});

            setLoanQuote({ ...updatedData, ...quotation?.[0], net_premium: quotation?.[0]?.total_premium_amount || 0, total_addons_premium:  quotation?.[0]?.total_addon_amount || 0, tenure: effectiveTenure, cashback_params: cashbackParams  })
            setNeedsRecalc(false);
            setDisplayBlock("SUMMARY");
            setShowApproveBtn(true);
        } else {
            toast.error(result?.data?.message);
        }

    }

    // function of validation RequiredField
    const validationRequiredField = () => {
        const { payment_term_id, plate_no, insurance_type_id, mv_number, pay_tenure, expected_installment, lead_source, referrer_mobile, referrer_name, lead_sub_source, application_type_id, paid_by_customer, premium_amount, premium_amount_date } = insuranceStateStore?.leadDetail;
        // expected date validation
        if (pay_tenure && application_type_id === APP_TYPE_STANDALONE && payment_term_id === INSTALLMENT) {
            const months = parseInt(pay_tenure.split(' ')[0], 10);
            // Check each installment date
            for (let i = 1; i <= months; i++) {
                if (!expected_installment || (expected_installment && !expected_installment[i])) {
                    toast.error("All fields are required.")
                    return false;
                }
            }
        }

        let checkKeysGlobal = ['customer_name', 'per_house_no', 'per_street', 'per_region', 'per_city', 'per_barangay', 'per_postal_code', 'fuel_type', 'is_under_financing', 'vehicle_seat']

        let isValid = true

        if (application_type_id !== APP_TYPE_AGENCY) {
            checkKeysGlobal = [...checkKeysGlobal, 'payment_method_id', 'payment_term_id', 'lead_source', 'mobile', 'email', 'insurance_policy_exists']
        } else {
            let updatecheckKeysGlobal = checkKeysGlobal.filter(key => !['per_house_no', 'per_street'].includes(key));
            checkKeysGlobal = [...updatecheckKeysGlobal, 'per_full_address']
        }
        for (let key of checkKeysGlobal) {
            if (!insuranceStateStore?.leadDetail?.[key]) {
                isValid = false
                break
            }
        }
        //|| ([APP_TYPE_AGENCY].includes(application_type_id) && +paid_from_agency === 1 && (!premium_amount || (!pay_tenure && !premium_amount_date))
        if (
            !isValid || (([APP_TYPE_STANDALONE, APP_TYPE_RENEWAL].includes(application_type_id) && +paid_by_customer === 1 && (!premium_amount || (!pay_tenure && !premium_amount_date))))
        ) {
            toast.error("All fields are required. Please fill in all the Customer Details.");
            return;
        }
        // for CTPL plate no or mv number required
        if (+insurance_type_id === INS_TYPE_CTPL && (!plate_no && !mv_number)) {
            toast.error("All fields are required. Please fill plate no or mv number");
            return false;
        }
        // Check if any of the required fields are empty
        if (ALLOW_LEAD_SOURCE.includes(lead_source) &&  ((!referrer_mobile || String(referrer_mobile).trim() === "") && (!referrer_name || referrer_name.trim() === ""))) {
            toast.error("All fields are required. Please fill in all the Other Details.");
            return false;
        }
        if (+lead_source === DSA_LEAD_SOURCE && (!referrer_name || referrer_name.trim() === "") && COUNTRY_CODE !== 'id') {
            toast.error("All fields are required. Please fill in all the Other Details.");
            return false;
        }
        if (+lead_source === MARKETING_LEAD_SOURCE && !lead_sub_source && COUNTRY_CODE !== 'id') {
            toast.error("All fields are required. Please fill in all the Other Details.");
            return false;
        }
        return true;
    };

    const saveInsurance = async () => {
        // check validation all required input field is filled or not
        if (insuranceState) {
            const isValid = await validationRequiredField()
            if (!isValid) {
                return false;
            }
        }
        let params: any = {
            lead_id: insuranceState.lead_id,
            insurance_type: insuranceState.insurance_type_id,
            rule_engine: insuranceState.rule_engine_id,
            user_id: insuranceState.user_id,
            role_id: insuranceState.role_id,
            lead_type: insuranceState.lead_type,
            partner_id: insuranceStateStore.leadDetail.partner_id,
            partner_slug: insuranceStateStore.leadDetail.partner_slug,
            apptype: insuranceState.application_type_id,
            tenure: insuranceState.tenure,
            referrer_mark_up: insuranceState.referrer_mark_up,
            car_fmv: insuranceState.fmv_car,
            acc_price: insuranceState.accessories_price,
            total_fmv: insuranceState.total_fmv,
            vehicle_usage: insuranceState.vehicle_id,
            vehicle_type: insuranceState.vehicle_type_id,
            make: insuranceState.make,
            model: insuranceState.model,
            version: insuranceState.version,
            make_name: insuranceState.make_name,
            model_name: insuranceState.model_name,
            version_name: insuranceState.version_name,
            make_year: insuranceState.mfg_year,
            plate_number: insuranceState.plate_no,
            fuel_type: insuranceState.fuel_type,
            transmission: insuranceState.transmission,
            seat_capacity: insuranceState.vehicle_seat,
            name: insuranceState.customer_name,
            phone: insuranceState.mobile,
            alt_phone: insuranceState.alternate_mobile ?? undefined,
            dob: insuranceState.dob,
            email: insuranceState.email,
            customer_type: insuranceState.customer_type,
            payment_method: insuranceState.payment_method_id,
            copy_of_insurance: insuranceState.copy_of_insurance,
            per_house_no: insuranceState.per_house_no,
            per_barangay: insuranceState.per_barangay,
            per_street: insuranceState.per_street,
            per_city: insuranceState.per_city,
            per_region: insuranceState.per_region,
            per_postal_code: insuranceState.per_postal_code,
            cur_house_no: insuranceState.cur_house_no,
            cur_barangay: insuranceState.cur_barangay,
            cur_street: insuranceState.cur_street,
            cur_city: insuranceState.cur_city,
            cur_region: insuranceState.cur_region,
            cur_postal_code: insuranceState.cur_postal_code,
            per_sameas_cur: insuranceState.per_sameas_cur,
            insurance_exists: insuranceState.insurance_exists,
            car_under_finance: +insuranceState.is_under_financing,
            ucf_lead_id: (insuranceState.ucf_lead_id) ? insuranceState.ucf_lead_id : 0,
            payment_tenure: insuranceState.payment_tenure_id || 0,
            mv_number:insuranceState.mv_number,
            referrer_name:insuranceState?.referrer_name,
            //referrer_mobile: insuranceState?.referrer_mobile && insuranceState.referrer_mobile !== 'null' ? String(insuranceState.referrer_mobile) : "",
            other_detail_dealer_id:insuranceState?.other_detail_dealer_id,
            lead_sub_source: insuranceState?.lead_sub_source || null

        }

        // handle referrer mobile
        if (insuranceState?.referrer_mobile && insuranceState.referrer_mobile !== 'null') {
            params.referrer_mobile = String(insuranceState.referrer_mobile);
        }

        if (insuranceState.application_type_id === 1) {
            params.dealer_id = insuranceState.user_id;
        }

        if (insuranceState.dealer_name) {
            params.dealer_name = insuranceState.dealer_name;
        }
        if (+insuranceState.is_under_financing === 1) {
            params.car_under_finance = +insuranceState.is_under_financing;
            params.finance_from_date = insuranceState.financing_from_date;
            params.finance_to_date = insuranceState.finance_to_date;
            params.financier = insuranceState.financier_id;
            params.financier_name = insuranceState.financier_name;
        }
        if (insuranceState.insurance_exists === 1) {
            params.insurer_name = insuranceState.insurer_name;
        }
        if (insuranceState.color) {
            params.color = insuranceState.color;
        }
        if (insuranceState.chassis_number) {
            params.chassis_number = insuranceState.chassis_number;
        }
        if (insuranceState.machine_number) {
            params.machine_number = insuranceState.machine_number;
        }
        if (insuranceState.accessories_description) {
            params.acc_description = insuranceState.accessories_description;
        }
        if([APP_TYPE_STANDALONE, APP_TYPE_RENEWAL,APP_TYPE_AGENCY].includes(insuranceState.application_type_id) && (insuranceState.discount || loanQuote?.discount)){
            params.discount= (loanQuote?.discount || loanQuote?.discount === 0) ? loanQuote.discount : insuranceState.discount;
        }

        if (![APP_TYPE_AGENCY].includes(insuranceState.application_type_id)) {
            params['payment_term'] = insuranceState.payment_term_id

        }

        params.net_premium = loanQuote?.net_premium || insuranceState.net_premium;
        params.add_on_rate = loanQuote?.base_issue_rate || insuranceState.add_on_rate
        params.referrer_mark_up = (loanQuote?.referrer_mark_up || loanQuote?.referrer_mark_up === 0) ? loanQuote?.referrer_mark_up : insuranceState.referrer_mark_up;
        
        let addon_detail = (addonList.length)?  getAddonList([],addonList) : insuranceState?.addon_detail;   
        
        //FOR CTPL & BIKE NO ADDONS
        if ([VEHICLE_TYPE_MOTORCYCLE, VEHICLE_TYPE_MOTORCYCLE_COMMERCIAL].includes(params?.vehicle_type_id) && params?.insurance_type === INS_TYPE_CTPL) {
            addon_detail = [];
        }

        params={...params,...leadDetails,...{addon_detail}};
        setLoading(true)
        // Loop to filter out properties with null values
        for (const key in params) {
            if (params[key] === null) {
                delete params[key];
            }
        }
        if (+params.car_under_finance === 2) {
            delete params.financier;
            delete params.finance_to_date;
            delete params.finance_from_date;
        }
        if (+params.insurance_exists === 2) {
            delete params.insurer_name;
            delete params.insurance_expire_date;
        }
        // add Lead Source and Other documents
        params.lead_source = insuranceState?.insurance_lead_source || 0
        params.other_doc = ((insuranceState?.other_doc && insuranceState?.other_doc?.length && typeof insuranceState?.other_doc === 'string') ? insuranceState?.other_doc.split(',') : insuranceState?.other_doc) || undefined

        if (insuranceState?.application_type_id === APP_TYPE_AGENCY) {
            params['per_full_address'] = insuranceState?.per_full_address
            params['cur_full_address'] = insuranceState?.cur_full_address
            params['agency_id'] = insuranceState?.agency_id
            params['paid_from_agency'] = 0

            let keysToDelete = ['ucf_lead_id', 'customer_type', 'lead_source', 'finance_from_date', 'finance_till_date', "insurance_exists", "payment_method", "paid_from_agency", "per_house_no", "per_barangay", "per_street", "per_city", "per_region", "per_postal_code", "cur_house_no", "cur_barangay", "cur_street", "cur_city", "cur_region", "cur_postal_code"]

            keysToDelete.forEach((key: string) => {
                delete params[key]
            })
        }

        const fields = ENCRYPTED_FIELDS;
        fields.forEach((field:any) => {
            if (params?.[field]) {
                params[field] = HELPER.EncodetoBase64(params[field]);
            }
        });
        let result: any = insuranceState?.application_type_id === APP_TYPE_AGENCY ? await AgencyService.createAgencyLead(params) : await InsuranceService.createLead(params);
        setLoading(false)
        if (result?.data?.data) {
            toast.success("Insurance updated successfully");
            //dispatch(getInsuranceDetails({ "leadId": queryParams.id }));
            fetchLeadData({ "lead_id": queryParams.id, apiType: API_TYPES['customerData'] }).then((res: any) => {
                if (res && res.status === STATUS_SUCCESS) {
                    //insuranceState
                    let leadDetails = allState?.insurance?.leadDetail
                    let updatedLeadDetails = {
                        ...leadDetails,
                        ...res.data,
                        quotes: {
                            ...leadDetails.quotes,
                            ...res?.data?.quotes
                        }
                    };
                    if (leadDetails?.status_id <= STATUS_SUB_STATUS['status']['sent_to_insurance_broker']) {

                        dispatch(getLeadEmailTemplates({ partner_id: +leadDetails?.partner_id, leadId: leadDetails?.leadId }))

                    }
                    dispatch(updateLeadDetailsInStore((updatedLeadDetails)))



                }
            });

            setLeadDetails({});
            setFormData([]);
            setLoanQuote(null)
            // updateLeadDetailsInStore({...leadDetails})
            setShowApproveBtn(false);
        } else {
            toast.error(result?.data?.message);
        }
    }
   
    const saveInsuranceID = async () => {
        setLoading(true)
        
        let addonListData =  getAddonListID(addonList?.basic?.concat(addonList?.special))

        addonListData =
        addonCount !== 0
            ? addonListData.length > 0
            ? addonListData
            : insuranceState?.addon_detail
            : [];
            
        let params = callServiceToUpdateLead({ ...insuranceState, tenure: effectiveTenure, is_shared: 2, share_insurer_ids: insuranceState?.insurer_id?.toString() }, { ...loanQuote, addon_detail: addonListData?.length ? addonListData : [],color: insuranceState?.color })        

        if (Array.isArray(params?.addon_detail)) { 
            params.addon_detail = params.addon_detail.map((item: any) => ({ ...item, premium_amount:typeof item.premium_amount === "string" ? Number(item.premium_amount) : item.premium_amount,}));
        }
        params.addon_detail = withAddonTenures(params.addon_detail);

        params.policy_holder = insuranceState.policy_holder
        if(insuranceState.policy_holder===POLICY_HOLDER['COMPANY']){
            params.npwp_no = insuranceState.npwp_no
            delete params.ktp_id
            delete params.marital_status
            delete params.gender
            delete params.dob
            delete params.city_birth
        }

        if(insuranceState?.rule_engine_id){
            params.rule_engine = insuranceState.rule_engine_id
        }
        
        params = {...params, insurer: params?.existing_insurer_name, expiration_date: params?.insurance_expire_date, rule_engine: params.rule_engine_id, insurer_name: params?.other_insurer_name}
        delete params['existing_insurer_name']
        delete params['insurance_expire_date']
        delete params['rule_engine_id']
        delete params['other_insurer_name']

        if(params?.insurance_exists === 2){
            delete params.insurer_name
            delete params.expiration_date
        }

        if(insuranceState?.lead_type === LEAD_TYPE_CRM) {
            delete params.role_id
        }

        if(insuranceState?.lead_type === LEAD_TYPE_CRM) {
            delete params.role_id
        }
        if(insuranceState?.branch_id) params.insurer_branch_id = insuranceState?.branch_id
        
        delete params.insurance_type;  
        params.tenure = effectiveTenure
        params.multi_year = getMultiYearPayload()
        // always persist the full policy period (start + tenure); CRM leads otherwise lose the end date
        if (insuranceState?.insurance_starting_date) {
            params.insurance_ending_date = moment(insuranceState.insurance_starting_date).add(effectiveTenure, 'year').format('YYYY-MM-DD')
        }
        if (loanQuote?.cashback_params) params = { ...params, ...loanQuote.cashback_params }
        params.customer_discount = 0
        params.per_postal_code = insuranceState?.per_postal_code
        params.cur_postal_code = insuranceState?.cur_postal_code
        
        const response = await AgencyService.createAgencyLead({ ...params, origin: 'web' })
        setLoading(false)

        if (response?.data?.data) {
            toast.success("Insurance updated successfully");
            //dispatch(getInsuranceDetails({ "leadId": queryParams.id }));
            fetchLeadData({ "lead_id": queryParams.id, apiType: API_TYPES['customerData'] }).then((res: any) => {
                if (res && res.status === STATUS_SUCCESS) {
                    //insuranceState
                    let leadDetails = allState?.insurance?.leadDetail
 
                    const allTenureAddons = res?.data?.addon_detail || [];
                    const selectedAddons = allTenureAddons?.filter((item: any) => +item.tenure===SELECTED_TENURE_YEAR);
                    res.data.addon_detail = selectedAddons;
                    res.data.addon_detail_all = allTenureAddons;
            
                    let updatedLeadDetails = {
                        ...leadDetails,
                        ...res.data,
                        quotes: {
                            ...leadDetails.quotes,
                            ...res?.data?.quotes
                        }
                    };
                    // if (leadDetails?.status_id <= STATUS_SUB_STATUS['status']['sent_to_insurance_broker']) {

                    //     dispatch(getLeadEmailTemplates({ partner_id: +leadDetails?.partner_id, leadId: leadDetails?.leadId }))

                    // }
                    dispatch(updateLeadDetailsInStore((updatedLeadDetails)))



                }
            });

            setLeadDetails({});
            setFormData([]);
            setLoanQuote(null)
            setShowApproveBtn(false);
            setTenure(0);
            setNeedsRecalc(false);
        } else {
            toast.error(response?.data?.message);
        }

        return
    }

    const parentchangeHandler = (params: any) => {
        calculateInsurance(formData, params);
    }

    const handleDownloadPdfClick = async () => {
        setLoading(true)
        let params = { lead_id: insuranceState?.hashId }
        let pdfResponse: any = await downloadLoanQuotationPdf(params)
        if (pdfResponse && pdfResponse.status && pdfResponse.status === STATUS_SUCCESS && pdfResponse.data && pdfResponse.data.link) {
            window.open(pdfResponse.data.link, '_blank')
        }
        setLoading(false)
    }

    const onValueChange = (fieldItem: any) => {
        if (fieldItem.name === "car_under_finance") {
            setFinanceType(+fieldItem.value.value);
            SetActNature();
        } else if (fieldItem.name === "insurance_type") {
            setInsuranceType(fieldItem.value.value);
            fetchAddons(fieldItem.value.value);
        } else if (fieldItem.name === "vehicle_type") {
            setVehicleType(fieldItem.value.value);
        }
        else if (fieldItem.name === "vehicle_usage") {
            setVehicleUsage(fieldItem.value.value);
        }
    }

    const SetActNature = async () => {
        let is_required = false;
        if (insuranceType === 1 && +financeType === 1) {
            is_required = true;
        }
        let originalList: any = addonList;
        if (originalList.length > 0) {
            originalList = originalList.map((ob: any) => {
                return {
                    ...ob, is_required: (ob.id === 6) ? is_required : ob.is_required,
                    is_selected: (ob.id === 6) ? is_required : ob.is_selected
                }
            })
            setAddonList([...originalList]);
            setValue(value + 1)
        }
    }

    const handleAddonPopupModal = (action: any) => {
        if (COUNTRY_CODE === 'id') {
            fetchAddonsID()
        } else {
            fetchAddons();
        }
        showHideAddons(false)
    }  
 
    return (
        <div className=" laon-expect-outer">
            <FullPageLoader show={loading} />
            <div className="loan-expect-left-panle">
                {/* defuat step start  */}
                {displayBlock === 'SUMMARY' ?
                    <div className="loan-form">
                        <div className="heading-top">
                            <span>{translations.Insurance?.['Insurance Calculator'] || translations.commonMsg?.loading}</span>
                            <div className="action-icn">
                                {
                                    COUNTRY_CODE !== 'id' &&
                                    insuranceState && insuranceState.leadId && insuranceState?.doc_status_id > 1 &&
                                    <ul>
                                        {insuranceState?.sub_status_id < STATUS_SUB_STATUS['subStatus']['sent_to_insurance_broker'] && HELPER.isUserHasUpdateAccess({ permissionID: ROLE_FEATURES['loan_expected'], accessType: 'edit', leadDetails: insuranceState, pageSlug: "customer_details" })
                                            && <li onClick={toggleswitch.bind(this, 'EDITVIEW')}>

                                                <i className="ic-createmode_editedit"></i>

                                            </li>}
                                        <li onClick={handleDownloadPdfClick}>
                                            <i className="ic-save_alt"></i>
                                        </li>
                                        <li onClick={showModalFinancerEmail}>
                                            <i className="ic-share"></i>
                                        </li>
                                    </ul>
                                }
                                {
                                    COUNTRY_CODE === 'id' &&
                                    insuranceState && insuranceState.leadId && insuranceState?.status_id < 2 &&
                                    <ul>
                                        {
                                            insuranceState?.status_id < 2 &&
                                            <li onClick={toggleswitch.bind(this, 'EDITVIEW')}>
                                                <i className="ic-createmode_editedit"></i></li>
                                        }
                                        <li onClick={handleDownloadPdfClick}>
                                            <i className="ic-save_alt"></i>
                                        </li>
                                        <li onClick={showModalFinancerEmail}>
                                            <i className="ic-share"></i>
                                        </li>
                                    </ul>
                                }
                            </div>
                        </div>
                        {
                            COUNTRY_CODE === 'id'
                                ?
                                <QuotesDetailID showApproveBtn={showApproveBtn} quotationDetails={(loanQuote) ? loanQuote : insuranceQuotesState} saveInsurance={saveInsuranceID} tenure={showApproveBtn ? effectiveTenure : getSavedTenure()} yearTypes={showApproveBtn ? getMultiYearPayload().map((row: any) => row.insurance_type) : getSavedYearTypes()} yearAddonSelections={yearAddonSelections} />
                                :
                                <QuotesDetail insuranceType={insuranceType} leadDetails={insuranceState} showApproveBtn={showApproveBtn} detail={(loanQuote) ? loanQuote : insuranceQuotesState} saveInsurance={saveInsurance} parentchangeHandler={parentchangeHandler} />
                        }
                    </div>
                    : null}
                {/* end  */}


                {/* loan edit step  */}
                {displayBlock === 'EDITVIEW' ?
                    <div className="loan-form">
                        <div className="heading-top">
                            <span>{translations.Insurance?.['Insurance Calculator'] || translations.commonMsg?.loading}</span>
                            <div className="action-icn">
                                <ul>
                                    {/* <li><i className="ic-save_alt"></i></li>
                                    <li><i className="ic-share"></i></li> */}
                                </ul>
                            </div>
                        </div>
                        {
                            COUNTRY_CODE === 'id'
                                ?
                                <QuotesDetailID formType={"EDIT"} addonCount={addonCount} toggleswitch={(e: any) => toggleswitch(e)} showHideAddons={showHideAddons} calculateInsurance={calculateInsuranceID} previewInsurance={previewInsuranceID}  addonList = {addonList} totalAddonPremiumAmt = {totalAddonPremiumAmt} setTotalAddonPremiumAmt = {setTotalAddonPremiumAmt} tenure={effectiveTenure} savedTenure={getSavedTenure()} onTenureChange={onTenureChange} yearTypes={getMultiYearPayload().map((row: any) => row.insurance_type)} yearAddonSelections={yearAddonSelections} needsRecalc={needsRecalc}/>
                                :
                                <InsuranceEditForm addonCount={addonCount} showHideAddons={showHideAddons} toggleswitch={(e: any) => toggleswitch(e)} calculateInsurance={calculateInsurance} leadDetails={insuranceState} insuranceType={insuranceType} onValueChange={onValueChange} />
                        }
                    </div>
                    : null}
                {/* end */}
            </div>

            <div className="loan-expect-right-panel">
                <LoanExpectedRightPanel vehicleTypeList={vehicleTypeList} />
            </div>

            <div className="view-timeline-popup addon-modal">
                {/* <Modal show={addons} handleClose={showHideAddons.bind(this, false)} > */}
                <Modal show={addons} handleClose={handleAddonPopupModal} >
                    <AddonForm setAddon={COUNTRY_CODE === 'id' ? setAddonID : setAddon} addonList={addonList} addonCount={addonCount} insuranceState={insuranceState} insuranceType={insuranceType} showHideAddons={showHideAddons}  setTotalAddonPremiumAmt = {setTotalAddonPremiumAmt} premiumAmountState={premiumAmountState} setPremiumAmountState={setPremiumAmountState} isAddonEdit={isAddonEdit} setIsAddonEdit={setIsAddonEdit} show={addons} tenure={effectiveTenure} initialYear={addonModalYear} yearAddonSelections={yearAddonSelections} yearRows={loanQuote?.addons_by_tenure || insuranceState?.lead_tenure_data || []} addonDetailAll={insuranceState?.addon_detail_all || []}/>
                </Modal>
            </div>

            {
                showShareLoanQuote ?
                COUNTRY_CODE === 'id'  ?
                <ShareQuotesDetailID show={showShareLoanQuote} handleClose={showModalFinancerEmail} setLoader={setLoading} addonList={addonList} addonCount={addonCount}/> :
                    <ShareQuotesDetail show={showShareLoanQuote} handleClose={showModalFinancerEmail} setLoader={setLoading} />
                    : null
            }

        </div>

    )
}

export default LoanExpected;
